import APIClient from '@/shared/http/clients/api'

const resourceName = 'parametros-serasa'
const APICore = process.env.APIBaseURLCore

const GetParams = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?page=0&size=1`, data, config)
const UpdateParams = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/${data.id}`, data, config)

const SerasaRepository = {
  GetParams,
  UpdateParams
}

export default SerasaRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configurations/serasa.js